import axios from "axios";
import { useEffect } from "react";
import type Nullable from "~/types/nullable";

export default function ViewCounter({ id }: { id: string }) {
  useEffect(() => {
    incrementViews(id);
  }, [id]);

  return null;
}

export async function incrementViews(id?: Nullable<string>) {
  if (id) {
    try {
      await axios.post(`/api/posts/${id}/views/increment`);
    } catch {}
  }
}
